import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { MenuCategoryEditFormFields } from 'page/MenuCategoryPage/types/menuCategoryEditFormFields';

type Props = {
  values: MenuCategoryEditFormFields;
  handleBack: () => void;
  handleSubmit: () => void;
};

export const MenuCategoryEditConfirmModalView: FC<Props> = ({
  values,
  handleBack,
  handleSubmit,
}) => (
  <form onSubmit={handleSubmit}>
    <ModalContent maxHeight="90vh">
      <ModalHeader p="40px">カテゴリーの更新</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>カテゴリーID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>カテゴリー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text align="center" fontWeight="bold" mt="60px">
          上記の内容でカテゴリーを更新しますか？
        </Text>
      </ModalBody>
      <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
        <Button
          w="140px"
          variant="outline"
          colorScheme="blackAlpha"
          onClick={handleBack}
        >
          入力画面に戻る
        </Button>
        <Button w="140px" colorScheme="blackAlpha" type="submit">
          更新
        </Button>
      </ModalFooter>
    </ModalContent>
  </form>
);
